import { openingTimeTableUrl } from "../resources";
import getRequest from '../common/getRequest.js';

async function getOpeningTimesByRestaurant(restaurantid) {
    
    let url = `${openingTimeTableUrl}/${restaurantid}`;
    let data;
    await getRequest.getData(url)
                .then(response => {
                    data = response.openingTimeTable });
    return data;
}

async function getCurrentLocalTime() {
    let url = `${openingTimeTableUrl}/getcurrentlocaltime`;
    let data;
    await getRequest.getData(url)
                .then(res => data = res);

    return data;
}

async function getCurrentOpeningHoursByRestaurant(restaurantId) {
    let url = `${openingTimeTableUrl}/getbyrestaurant/${restaurantId}`;
    let data;
    await getRequest.getDataWithToken(url)
                .then(res => {
                    data = res
                });
    return data;
}


export default {
    getOpeningTimesByRestaurant,
    getCurrentLocalTime,
    getCurrentOpeningHoursByRestaurant
}

